/* eslint-disable react-hooks/exhaustive-deps */
import { LayoutProps, rankWith, uiTypeIs } from "@jsonforms/core";
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from "@jsonforms/react";
import { useEffect, useState } from "react";
import { useGetDownloadUrl} from "../../../../../hooks/NetworkHooks";
import { useQParam } from "../../../../../hooks/useQParam";
import { SuccessIcon } from "../../../../../icons/truWeb-icons";
import {
  getActions,
  getElements,
  getLabel,
} from "../../../../../utils/DynamicForms";
import { useDynamicFormContext } from "../../../DynamicFormContext";
import "./style.scss";

type Props = LayoutProps;

const PaymentSuccessLayout = (props: Props) => {
  const requestKey = useQParam("requestKey");
  const [requestDocumentState, setRequestDocument] = useState([]);
  const getDownloadUrl = useGetDownloadUrl();
  const { handleActions } = useDynamicFormContext();
  const actions = getActions(props.uischema);
  const elements = getElements(props.uischema);
  const label = getLabel(props.uischema);
  const options = props?.uischema?.options;
  const getElementByType = (type: string) =>
    getElements(props.uischema).find((el) => el.type === type) || ({} as any);


  useEffect(() => {
    if (props.visible && actions) {
      handleActions(actions);
    }
  }, [props.visible]);

  useEffect(() => {
    if (requestDocumentState?.length <= 0 && elements.length > 0)
      setTimeout(() => {
        handleFetchRequestDocument();
      }, 10000);
  });

  const handleFetchRequestDocument = async () => {
    if (
      !requestKey ||
      requestDocumentState?.length > 0 ||
      elements.length === 0
    )
      return false;

    const requestData = await fetch(
      `${window.location.origin}/wp-json/trumarket/v1/request/${requestKey}/attachment`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    const requestDocumentResponse = await requestData.json();
    setRequestDocument(requestDocumentResponse.data);
  };

  const handleDownloadDocument = async (key: string[], allDocs: boolean) => {
    await getDownloadUrl(key, allDocs);
  };

  if (!props.visible) return null;


  return (
    <div className="tru-layout-documents">
      <SuccessIcon />
      <h3>{label}</h3>
      <p>{options?.message}</p>
      {(elements.length > 0 && elements.find((el) => el.type === "DocumentSection")) && (
        <div className="document-wrapper">
          <p className="list-header">
            <span>{options?.documentsSectionLabel ? options?.documentsSectionLabel : "Documents" }</span>
            <div>
              {
                getElements(props.uischema).find((el) => el.type === "DownloadAllButton") ?                   
                  ( 
                    <button className="DownloadAll" disabled={!requestDocumentState?.length}
                      onClick={() => {
                        handleDownloadDocument(requestDocumentState.map((doc:any)=> doc.key), true)
                      }}
                    >
                      {options?.DownloadAllLabel ? options.DownloadAllLabel : "Download All"}
                    </button>
                  ) : null}
            </div>
          </p>
          <ul className="document-list">
            {requestDocumentState?.length ? (
              requestDocumentState?.map((doc: any) => (
                <li key={doc.key}>
                  <p> {doc.name} </p>
                  <span
                    onClick={() => {
                      handleDownloadDocument([doc.key],false);
                    }}
                  >
                    {options?.DownloadLabel ? options?.DownloadLabel : "Download" }
                  </span>
                </li>
              ))
            ) : (
              <div className="tru-docs-loading">
                <span className="loading-anim"></span>
              </div>
            )}
          </ul>
        </div>
      )}

      {elements.find((el) => el.type === "HorizontalFields") &&  (
            <div className="quote-btns">
              <ResolvedJsonFormsDispatch
              {...props}
              uischema={getElementByType("HorizontalFields")}
              />
            </div>
      )} 
    </div>
  );
};

export const PaymentSuccessEntry = {
  tester: rankWith(1, uiTypeIs("PaymentSuccessLayout")),
  renderer: withJsonFormsLayoutProps(PaymentSuccessLayout),
};
